import { render, staticRenderFns } from "./FeedbackSubjectEdit.vue?vue&type=template&id=6dda7cb0&lang=pug"
import script from "./FeedbackSubjectEdit.vue?vue&type=script&lang=js"
export * from "./FeedbackSubjectEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports